var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ScrollElement",class:{'sticky': _vm.sticky, 'bg': _vm.bg},style:({'min-height': _vm.mh, 'height': _vm.h, top: _vm.t, 'flex-direction': _vm.flexdirection, 'justify-content': _vm.justify})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }